import { gql } from '@apollo/client';

// 更新使用者屬性（半管理員、已驗證）
export const UPDATE_USER_ATTRIBUTES = gql`
  mutation UpdateUserAttributes($userId: ID!, $isSemiAdmin: Boolean, $isVerified: Boolean) {
    updateUserAttributes(userId: $userId, isSemiAdmin: $isSemiAdmin, isVerified: $isVerified) {
      success
      message
      user {
        id
        username
        email
        status
        profileOpen
        isActive
        isSemiAdmin
        isVerified
        lastLogin
        createdAt
      }
      errors {
        field
        message
      }
    }
  }
`;

// Ban/Unban 使用者
export const BAN_USER = gql`
  mutation BanUser($userId: ID!, $shouldBan: Boolean) {
    banUser(userId: $userId, shouldBan: $shouldBan) {
      success
      message
    }
  }
`;

